<template>
  <Error>
    <Provider>
      <!-- 전체 텍스트 크기 테스트 -->
      <template v-if="isRender">
        <component :is="layout.component">
          <router-view/>
        </component>
      </template>
    </Provider>
  </Error>
</template>


<script setup>
import {defineAsyncComponent, onMounted, ref, watch, markRaw} from "vue";
import Provider from "@/ui/Provider.vue";
import Error from "@/ui/Error.vue";
import router from "@/GenerationRouter";

// const loading = ref(true)
const isRender = ref(false);
const layout = ref({component: undefined, history: undefined});

watch(router.instance.currentRoute, () => {
  let meta = router.instance.currentRoute.value?.meta;
  let _layout = meta?.layout ?? '/ui/layout/DefaultLayout';
  if (meta?.nested == true && _layout == layout.value.history) {
    return;
  }
  layout.value.history = _layout;
  layout.value.component = markRaw(defineAsyncComponent(() => import(`.${_layout}.vue`)))
})

onMounted(() => {
  isRender.value = true;
});
</script>

<style lang="scss">
</style>
